/**
 * HeroPoster — Suspense fallback (and SSR initial paint) for the cinematic
 * branch. Renders the real Veo segment-01 frame 0 as a background image,
 * so the first paint reads as the actual brand aesthetic rather than the
 * legacy panel-stack SVG. The cinematic <HeroPin> swaps in once its chunk
 * loads.
 *
 * v1.0.3: PosterSvg removed entirely. The inline panels SVG was a v0.5
 * leftover whose aesthetic stopped matching the v1.0 hero. Falling back to
 * the photoreal Veo frame keeps the brand cohesive at first paint.
 */
export function HeroPoster() {
  return (
    <section className="hero hero--poster" data-scene="cinema">
      <div
        className="hero-poster-art"
        role="img"
        aria-label="Stone-facade Hollywood Regency mansion at golden hour with grand black-lacquer double doors standing open."
        style={{ backgroundImage: 'url(/posters/hero-poster.jpg)' }}
      />
      <div className="hero-copy hero-copy--static">
        <p className="eyebrow">Brian Ellison Design — Melbourne, Florida</p>
        <h1 className="hero-copy__headline">
          Interiors composed like<br />
          <span className="display-italic">architecture</span>.
        </h1>
        <p className="subtitle">
          Multidisciplinary luxury interior design. Residential, commercial, and hospitality
          projects across Brevard County and beyond.
        </p>
        <a href="/projects" className="cta-primary">See the work</a>
      </div>
    </section>
  );
}

